import CallMadeIcon from '@mui/icons-material/CallMade';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import { List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import Box from '@mui/material/Box';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { API } from '_helpers';

interface Props {
  data: CCommunity;
}

const Section8: React.FC<Props> = ({ data }) => {
  const { push } = useRouter();
  return (
    <Container sx={{ py: 10 }}>
      <Box
        sx={{
          position: 'relative',
          p: { xs: 0, md: 4 },
          '&::before': {
            content: '""',
            width: 20,
            height: 20,
            borderBottom: '2px solid white',
            borderLeft: '2px solid white',
            position: 'absolute',
            bottom: 0,
            left: 0,
          },
        }}
      >
        <Grid
          container
          spacing={4}
          sx={{ width: { xs: 1, md: 0.8 }, mx: 'auto' }}
        >
          <Grid item xs={12} md={6}>
            <Stack
              sx={{
                height: 1,
                width: 900,
                position: 'absolute',
                top: '100px',
                left: '-250px',
                background:
                  'radial-gradient(circle, rgba(51,57,114,0.7) 0%, rgba(252,70,107,0) 60%)',
                zIndex: 0,
              }}
            ></Stack>
            <Stack
              justifyContent="space-between"
              sx={{
                width: 1,
                height: 400,
                borderRadius: 6,
                py: 4,
                position: 'relative',
              }}
              spacing={4}
            >
              <Stack
                spacing={3}
                sx={{ '&>p': { fontSize: { xs: 18, md: 24 } } }}
              >
                <Typography variant="h1" sx={{ lineHeight: 1.6 }}>
                  {data?.title}
                </Typography>
                <Typography color="text.secondary">
                  {data?.description}
                </Typography>
                {data?.button?.path && (
                  <a href={data?.button?.path} target="_blank" rel="noreferrer">
                    <Stack
                      alignItems="center"
                      direction="row"
                      spacing={1}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          transform: 'translateX(8px)',
                          transition: '500ms',
                        },
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: 18, md: 24 } }}>
                        {data?.button?.label}
                      </Typography>
                      <CallMadeIcon fontSize="small" />
                    </Stack>
                  </a>
                )}
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <List>
              {data?.items?.map((el, i) => (
                <ListItem key={i} sx={{ py: 2 }}>
                  <ListItemAvatar sx={{ mt: '-30px', mr: 2 }}>
                    <Stack
                      sx={{
                        width: 50,
                        height: 50,
                        position: 'relative',
                      }}
                    >
                      <Image
                        alt={el.media.alternativeText}
                        src={`${API}${el.media.url}`}
                        layout="fill"
                        objectFit="contain"
                      />
                    </Stack>
                  </ListItemAvatar>
                  <ListItemText
                    primaryTypographyProps={{
                      typography: 'h3',
                      fontWeight: 600,
                      py: 1,
                    }}
                    secondaryTypographyProps={{
                      fontSize: '1.3rem',
                      color: 'text.secondary',
                    }}
                    primary={
                      <a href={el?.path} target="_blank" rel="noreferrer">
                        <Stack
                          alignItems="center"
                          direction="row"
                          spacing={1}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              transform: 'translateX(8px)',
                              transition: '500ms',
                            },
                          }}
                        >
                          <Typography sx={{ fontSize: { xs: 18, md: 24 } }}>
                            {el?.name}
                          </Typography>
                          <CallMadeIcon fontSize="small" />
                        </Stack>
                      </a>
                    }
                    secondary={el?.description}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Section8;
